module.exports = __webpack_public_path__ + "static/ButterReplacement-10a6bd5a544036aa77f390ef3eab0db9.webp";